import { CircularProgress } from '@insta-club/ui';
import { cn } from '@insta-club/utilities';

interface Props {
    data: {
        post: string;
        algoritm: string;
        story: string;
    };
}

const AvgTasks = ({ data }: Props) => {
    const cardConfigs = [
        {
            key: 'post' as keyof typeof data,
            label: 'برنامه پست گذاری',
            bgColor: 'bg-primary-400',
            borderColor: 'border-primary-100'
        },
        {
            key: 'story' as keyof typeof data,
            label: 'برنامه استوری',
            bgColor: 'bg-primary-400',
            borderColor: 'border-primary-100'
        },
        {
            key: 'algoritm' as keyof typeof data,
            label: 'برنامه الگوریتمی',
            bgColor: 'bg-primary-400',
            borderColor: 'border-primary-100'
        }
    ];

    return (
        <div className='flex justify-around gap-2 sm:gap-3'>
            {cardConfigs.map((config) => {
                const percentage = parseFloat(data[config.key]) || 0;

                return (
                    <div
                        key={config.key}
                        className={cn(
                            'relative flex w-1/3 flex-col items-center justify-center space-y-1 overflow-hidden rounded-lg p-4 text-center text-white',
                            config.bgColor
                        )}
                    >
                        <div
                            className={cn(
                                'absolute top-0 left-0 h-18 w-18 -translate-x-1/2 -translate-y-1/2 rounded-full border-[7px]',
                                config.borderColor
                            )}
                        />
                        <CircularProgress
                            percentage={percentage}
                            size={40}
                            barColor={cn({
                                'text-green-500': percentage > 70,
                                'text-warning-500': percentage >= 40 && percentage <= 70,
                                'text-danger-500': percentage < 40
                            })}
                            strokeWidth={4.5}
                            textColor='text-white'
                        />
                        <div className='space-x-1 text-sm font-medium'>
                            <span>{config.label}</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default AvgTasks;

